var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalleticon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Page 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "main---search",
    transform: "translate(-38.000000, -268.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(38.000000, 268.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "M17.4,13.2c0.2,0,0.3,0.1,0.3,0.3s-0.1,0.3-0.3,0.3c-0.2,0-0.3-0.1-0.3-0.3 S17.2,13.2,17.4,13.2z M17.4,12.1c-0.8,0-1.4,0.6-1.4,1.4s0.6,1.4,1.4,1.4s1.4-0.6,1.4-1.4S18.2,12.1,17.4,12.1z M14.6,10.9h8.2 V16h-8.2c-0.2,0-0.3-0.1-0.3-0.3v-4.6C14.3,11.1,14.4,10.9,14.6,10.9z M1.2,5.8C1.5,6,1.9,6.1,2.3,6.1c6.4,0,14.1,0,19.6,0 c0.5,0,0.9,0.4,0.9,0.9v2.8h-8.2c-0.8,0-1.4,0.6-1.4,1.4v4.6c0,0.8,0.6,1.4,1.4,1.4h8.2V20c0,0.5-0.4,0.9-0.9,0.9H2 c-0.5,0-0.9-0.4-0.9-0.9V5.8H1.2z M2.3,2.7h17.1V5H2.3C1.7,5,1.2,4.5,1.2,3.8S1.7,2.7,2.3,2.7z M2.3,1.5C1,1.5,0,2.5,0,3.8V20 c0,1.1,0.9,2,2,2h20c1.1,0,2-0.9,2-2V7c0-1.1-0.9-2-2-2h-1.4V2.1c0-0.3-0.3-0.6-0.6-0.6C20,1.5,2.3,1.5,2.3,1.5z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalleticon);
export default __webpack_public_path__ + "static/media/wallet.icon.bb4c6114456c146b62511cac244f9a04.svg";
export { ForwardRef as ReactComponent };